import EventBus from '../services/service.eventBus';
import { state as answerState, onChange as onAnswerChange } from '../store/store.answers';
import { state as autoCheckState } from '../store/store.autocheck';
import { state as historyState } from '../store/store.history';
import { state as pageParamsState } from '../store/store.page-params';
import { state as validationState } from '../store/store.validation';
import { getVehicleHistoryProperties } from '../utils/utils.answers';
import { QUESTION_ARE_QUESTIONS_VERIFIED, QUESTION_ORIGINAL_OWNER, QUESTION_VEHICLE_AUCTION, QUESTION_VEHICLE_ISSUES, QUESTION_VEHICLE_RENTAL } from '../utils/utils.question';

import { onQuestionAnswered } from './actions.answers';

// Combine with contact form???
export const onVehicleHistoryFormInit = () => {
  validateVehicleHistory(true);

  onAnswerChange('history', () => validateVehicleHistory());

  const answers = answerState.history;
  EventBus.publish('QuestionAnsweredInit', { answers });
};

const onReceivedParams = ({ isAdmin }) => {
  try {
    onReceivedParamsSuccess({ isAdmin });
  } catch (error) {
    onReceivedParamsFail(error);
  }
};

const onReceivedParamsSuccess = ({ isAdmin }) => {
  EventBus.publish('ReceivedParams', { isAdmin });
  setHistoryQuestions({ isAdmin });
  EventBus.publish('ReceivedParamsSuccess', { isAdmin });
};

const onReceivedParamsFail = (error) => {
  EventBus.publish('ReceivedParamsFail', error);
};

const setHistoryQuestions = ({ isAdmin }) => {
  if (isAdmin) {
    const historyQuestions = historyState.questions.filter((question) => question.questionId !== QUESTION_VEHICLE_AUCTION);
    historyState.questions = historyQuestions;
  } else if (!validationState.result.vehicleHistory) {
    onQuestionAnswered(QUESTION_VEHICLE_AUCTION, '');
  }
};

export const lockQuestion = (question) => {
  if (!pageParamsState.isAdmin) {
    return;
  }

  const { questionId } = question;
  const { other } = answerState;

  if (questionId === QUESTION_VEHICLE_ISSUES) {
    return autoCheckState?.hasAccidents;
  }

  const questionsVerified = other[QUESTION_ARE_QUESTIONS_VERIFIED].value > 0;
  return questionsVerified && [QUESTION_ORIGINAL_OWNER, QUESTION_VEHICLE_RENTAL].includes(questionId);
};

export const validateVehicleHistory = (strobe: boolean = false) => {
  const historyAnswers = answerState.history;
  const errors = new Set<string>();
  const { dealerInfo = { dealerGuid: '' } } = answerState || {};
  const { dealerGuid } = dealerInfo;
  const { hasVehicleAuction, hasVehicleIssues, hasVehicleRental, isOriginalOwner } = getVehicleHistoryProperties(historyAnswers);

  if (isOriginalOwner === '' || isOriginalOwner === undefined) {
    errors.add(QUESTION_ORIGINAL_OWNER);
  }

  if (hasVehicleIssues === '' || hasVehicleIssues === undefined) {
    errors.add(QUESTION_VEHICLE_ISSUES);
  }

  if (!pageParamsState.isAdmin && (hasVehicleAuction === '' || hasVehicleAuction === undefined)) {
    errors.add(QUESTION_VEHICLE_AUCTION);
  }

  if (hasVehicleRental === '' || hasVehicleRental === undefined) {
    errors.add(QUESTION_VEHICLE_RENTAL);
  }

  if (hasVehicleAuction === true && dealerGuid === '') {
    errors.add(QUESTION_VEHICLE_AUCTION);
    validationState.fields = {
      ...validationState.fields,
      vehicleHistory: {
        ...validationState.fields.vehicleHistory,
        [QUESTION_VEHICLE_AUCTION]: 'Vehicle is ineligible',
      },
    };
  }

  const newIsValid = !errors.size;
  const oldIsValid = validationState.result.vehicleHistory;

  validationState.form = {
    ...validationState.form,
    vehicleHistory: errors,
  };

  validationState.result = {
    ...validationState.result,
    vehicleHistory: newIsValid,
  };

  if (strobe || newIsValid !== oldIsValid) {
    EventBus.publish('FormValidated', { form: 'vehicle-history-form', isValid: newIsValid });
  }
};

export default {
  onReceivedParams,
};
